import { render, staticRenderFns } from "./PB-Signature.vue?vue&type=template&id=1d92b976&scoped=true&"
import script from "./PB-Signature.vue?vue&type=script&lang=js&"
export * from "./PB-Signature.vue?vue&type=script&lang=js&"
import style0 from "./PB-Signature.vue?vue&type=style&index=0&id=1d92b976&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d92b976",
  null
  
)

export default component.exports